import { Box, Stack, styled, Typography } from '@planne-software/uni/mui/material';

export const QuantitySection = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  paddingTop: theme.tokens.spacing['spacing-2xmini'],
}));

export const QuantityLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-medium'],
  color: theme.tokens.colors['text-color-neutral-strong'],
  display: 'block',
}));

export const QuantityControls = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.tokens.spacing['spacing-1xmini'],
}));

export const QuantityValueBox = styled(Box)(({ theme }) => ({
  width: '2.125rem',
  height: '2.125rem',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${theme.tokens.spacing['spacing-2xmini']} ${theme.tokens.spacing['spacing-mini']}`,
  borderRadius: theme.tokens.radius['border-radius-xs'],
  border: `1px solid ${theme.tokens.colors['border-color-neutral-strong']}`,
  backgroundColor: theme.tokens.colors['fill-color-neutral'],
  boxShadow: theme.tokens.shadow['shadow-xs'],
}));

export const QuantityValueText = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-xs-medium'],
  color: theme.tokens.colors['text-color-neutral-strong'],
  textAlign: 'center',
  minWidth: 12,
}));
